import { IonSpinner } from "@ionic/react";
import { Redirect, Route } from "react-router-dom";
import { useAuthStore } from "../stores/auth.store";

const PrivateRoute = ({ component: Component, ...params }: any) => {
  const [user, loading] = useAuthStore(state => [state.user, state.loading]);
  return loading ? (
    <div className="ion-text-center p-4">
      <IonSpinner />
    </div>
  ) : (
    <Route
      {...params}
      render={props =>
        user ? <Component {...props} /> : <Redirect to="/intro" />
      }
    />
  );
};

export default PrivateRoute;
